import React from "react";
import ConfigSection from "../../ConfigSection";

const ShiftTypeSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Shift Type'
      configType='ShiftType'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default ShiftTypeSection;
